<template>
  <b-container fluid class="pwa-page">
    <b-row class="justify-content-center">
      <b-col cols="12" sm="10" md="7" lg="5">
        <div class="pwa-panel">
          <img
            src="/img/icons/apple-icon-180x180.png"
            alt="XGoal"
            class="pwa-icon"
          />
          <h1>XGoal</h1>
          <p class="pwa-intro">
            Add XGoal to your Home Screen for a better gaming experience.
          </p>

          <ol class="pwa-steps">
            <li>Open this page in Safari on your iPhone or iPad.</li>
            <li>Tap the Share button in the Safari toolbar.</li>
            <li>Select <strong>Add to Home Screen</strong>.</li>
            <li>Tap <strong>Add</strong> to finish the installation.</li>
          </ol>

          <b-button to="/" variant="primary" class="pwa-button">
            Back to the game
          </b-button>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "Pwa",
};
</script>

<style scoped>
.pwa-page {
  min-height: 100vh;
  padding: 32px 16px;
  background: linear-gradient(145deg, #0b40a2 0%, #06245c 100%);
}
.pwa-panel {
  margin-top: 8vh;
  padding: 32px 24px;
  color: #172033;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 12px 32px #00000040;
  text-align: center;
}
.pwa-icon {
  width: 96px;
  height: 96px;
  margin-bottom: 20px;
  border-radius: 20px;
}
h1 {
  margin-bottom: 12px;
  font-size: 28px;
}
.pwa-intro {
  margin-bottom: 24px;
  color: #526078;
}
.pwa-steps {
  padding-left: 24px;
  margin-bottom: 28px;
  text-align: left;
  line-height: 1.7;
}
.pwa-button {
  width: 100%;
}
</style>
